export enum InventoryGroupName {
  BrowsingAndSingleTasks,
  Collaborating,
  AppsAndVirtualization,
  PowerUsage,
  BasicClassroomUse,
  LearningAnywhere,
  AdvancedUse
}

export class InventoryGroup {
  name: InventoryGroupName = InventoryGroupName.BrowsingAndSingleTasks;
  minimumRAM: number = 0;
  minimumStorage: number = 0;
  allowedCPUs: string[] = [];
  priority: number = 0;
  needToRunOptions: string[] = [];
  userTypeNames: string[] = [];
  parallelsSelected: boolean = false;
}
